import { deleteField, doc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { db } from './firebase';
import { DailyAttendanceStatus, getDailyAttendancePath, isStudentAbsent } from './classAttendance';

export const setStudentAbsentStatus = async (args: {
  schoolId: string;
  classId: string;
  dateKey: string;
  studentId: string;
  absent: boolean;
  actorUid: string;
}): Promise<void> => {
  const { schoolId, classId, dateKey, studentId, absent, actorUid } = args;
  const attendanceRef = doc(db, getDailyAttendancePath(schoolId, classId, dateKey));

  if (!absent) {
    await updateDoc(attendanceRef, {
      [`records.${studentId}`]: deleteField(),
      updatedAt: serverTimestamp(),
      updatedBy: actorUid
    });
    return;
  }

  await setDoc(
    attendanceRef,
    {
      date: dateKey,
      updatedAt: serverTimestamp(),
      updatedBy: actorUid
    },
    { merge: true }
  );
  await updateDoc(attendanceRef, {
    [`records.${studentId}`]: 'absent' satisfies DailyAttendanceStatus,
    updatedAt: serverTimestamp(),
    updatedBy: actorUid
  });
};

export const toggleStudentAbsentStatus = async (args: {
  schoolId: string;
  classId: string;
  dateKey: string;
  studentId: string;
  records: Record<string, DailyAttendanceStatus>;
  actorUid: string;
}): Promise<void> => {
  const isAbsent = isStudentAbsent(args.records, args.studentId);
  await setStudentAbsentStatus({
    schoolId: args.schoolId,
    classId: args.classId,
    dateKey: args.dateKey,
    studentId: args.studentId,
    absent: !isAbsent,
    actorUid: args.actorUid
  });
};
